import { OriginProps, parserRegisterOrigin } from '@acme/common'
import { Button } from '@/global/components/Button'
import CircularProgress from '@/global/components/CircularProgress'
import Dialog from 'global/guides/Dialog'
import { PrinterIcon } from 'lucide-react'
import { useState } from 'react'
import { useOutletContext, useParams } from 'react-router-dom'
import { Registro, registros as registrosApi } from 'service/api'
import { FormularioDetalhesRegistro } from 'templates/ManutencaoDoPonto/Digitacao/forms/FormDetalhesRegistro'

export default function DetalhesRegistroReadOnly() {
    const { registroId } = useParams()
    const { data } = useOutletContext<{ data?: Registro[] }>()
    const [isImprimindo, setIsImprimindo] = useState(false)
    const registro = data?.find(registro => registro.id === Number(registroId))

    if (!registro) return null

    const { title, exibirComprovante } = parserRegisterOrigin(
        registro.origem,
    ) as OriginProps

    const handleClickComprovante = async () => {
        setIsImprimindo(true)
        registrosApi
            .pdf({
                queryParam: { id: registro?.id },
            })
            .finally(() => setIsImprimindo(false))
    }

    return (
        <Dialog.Root
            disableFields
            defaultValues={{
                ...registro,
                origem: title,
                endereco: registro?.Local?.endereco,
            }}
            height="auto"
        >
            <Dialog.Title>
                <h6 className="text-lg font-semibold text-foreground">
                    Detalhes do registro
                </h6>
                {!registro?.deletedAt && exibirComprovante && (
                    <Button
                        variant="outlined"
                        startIcon={
                            isImprimindo ? (
                                <CircularProgress size={20} />
                            ) : (
                                <PrinterIcon />
                            )
                        }
                        onClick={handleClickComprovante}
                    >
                        comprovante
                    </Button>
                )}
            </Dialog.Title>
            <Dialog.Content dividers>
                <FormularioDetalhesRegistro />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
